import React from 'react';
import { IProps } from './interfaces';

const KrGateway: React.FC<IProps> = ({
  size = 32,
  color = '#FF6900',
  className,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.21 17.57H20.38V11.96C20.38 11.73 20.57 11.54 20.8 11.54H23.04C23.31 12.75 24.4 13.66 25.69 13.66C27.19 13.66 28.42 12.44 28.42 10.93C28.42 9.42 27.2 8.2 25.69 8.2C24.39 8.2 23.31 9.11 23.04 10.32H20.8C19.91 10.32 19.18 11.05 19.18 11.94V17.55H16.61V6.38C17.82 6.11 18.74 5.02 18.74 3.73C18.74 2.23 17.52 1 16.01 1C14.5 1 13.28 2.22 13.28 3.73C13.28 5.03 14.19 6.11 15.4 6.38V17.57H12.85V9.31C12.85 8.42 12.13 7.7 11.24 7.7H8.9C8.7 6.39 7.58 5.39 6.22 5.39C4.72 5.39 3.49 6.61 3.49 8.12C3.49 9.63 4.71 10.85 6.22 10.85C7.45 10.85 8.47 10.03 8.82 8.91H11.24C11.47 8.91 11.65 9.09 11.65 9.32V17.58H5.8C2.6 17.57 0 20.17 0 23.36C0 26.55 2.6 29.15 5.79 29.15H26.2C29.39 29.15 31.99 26.55 31.99 23.36C31.99 20.17 29.39 17.57 26.2 17.57H26.21ZM25.69 9.41C26.53 9.41 27.21 10.09 27.21 10.93C27.21 11.77 26.53 12.45 25.69 12.45C24.85 12.45 24.16 11.77 24.16 10.93C24.16 10.09 24.84 9.41 25.69 9.41ZM6.22 9.63C5.38 9.63 4.7 8.95 4.7 8.1C4.7 7.25 5.38 6.58 6.22 6.58C7.06 6.58 7.75 7.26 7.75 8.1C7.75 8.94 7.07 9.63 6.22 9.63ZM14.48 3.72C14.48 2.88 15.16 2.2 16.01 2.2C16.86 2.2 17.53 2.88 17.53 3.72C17.53 4.56 16.85 5.25 16.01 5.25C15.17 5.25 14.48 4.57 14.48 3.72ZM26.21 27.35H5.79C3.59 27.35 1.8 25.56 1.8 23.36C1.8 21.16 3.59 19.37 5.79 19.37H26.2C28.4 19.37 30.19 21.16 30.19 23.36C30.19 25.56 28.4 27.35 26.2 27.35H26.21Z"
        fill={color}
      />
      <path
        d="M20.72 21.28C19.57 21.28 18.64 22.21 18.64 23.36C18.64 24.51 19.57 25.44 20.72 25.44C21.87 25.44 22.8 24.51 22.8 23.36C22.8 22.21 21.87 21.28 20.72 21.28ZM20.72 24.24C20.24 24.24 19.84 23.85 19.84 23.36C19.84 22.87 20.23 22.48 20.72 22.48C21.21 22.48 21.6 22.87 21.6 23.36C21.6 23.85 21.21 24.24 20.72 24.24Z"
        fill={color}
      />
      <path
        d="M26.68 21.28C25.53 21.28 24.6 22.21 24.6 23.36C24.6 24.51 25.53 25.44 26.68 25.44C27.83 25.44 28.76 24.51 28.76 23.36C28.76 22.21 27.83 21.28 26.68 21.28ZM26.68 24.24C26.2 24.24 25.8 23.85 25.8 23.36C25.8 22.87 26.19 22.48 26.68 22.48C27.17 22.48 27.56 22.87 27.56 23.36C27.56 23.85 27.17 24.24 26.68 24.24Z"
        fill={color}
      />
      <path
        d="M4.08999 21.28C3.75999 21.28 3.48999 21.55 3.48999 21.88V24.84C3.48999 25.17 3.75999 25.44 4.08999 25.44C4.41999 25.44 4.68999 25.17 4.68999 24.84V21.88C4.68999 21.55 4.41999 21.28 4.08999 21.28Z"
        fill={color}
      />
      <path
        d="M6.45999 21.28C6.12999 21.28 5.85999 21.55 5.85999 21.88V24.84C5.85999 25.17 6.12999 25.44 6.45999 25.44C6.78999 25.44 7.05999 25.17 7.05999 24.84V21.88C7.05999 21.55 6.78999 21.28 6.45999 21.28Z"
        fill={color}
      />
      <path
        d="M8.83999 21.28C8.50999 21.28 8.23999 21.55 8.23999 21.88V24.84C8.23999 25.17 8.50999 25.44 8.83999 25.44C9.16999 25.44 9.43999 25.17 9.43999 24.84V21.88C9.43999 21.55 9.16999 21.28 8.83999 21.28Z"
        fill={color}
      />
      <path
        d="M12.45 22.8H12.04C11.8412 22.8 11.68 22.9612 11.68 23.16V23.57C11.68 23.7688 11.8412 23.93 12.04 23.93H12.45C12.6488 23.93 12.81 23.7688 12.81 23.57V23.16C12.81 22.9612 12.6488 22.8 12.45 22.8Z"
        fill={color}
      />
      <path
        d="M14.27 22.8H13.86C13.6612 22.8 13.5 22.9612 13.5 23.16V23.57C13.5 23.7688 13.6612 23.93 13.86 23.93H14.27C14.4688 23.93 14.63 23.7688 14.63 23.57V23.16C14.63 22.9612 14.4688 22.8 14.27 22.8Z"
        fill={color}
      />
      <path
        d="M16.09 22.8H15.68C15.4812 22.8 15.32 22.9612 15.32 23.16V23.57C15.32 23.7688 15.4812 23.93 15.68 23.93H16.09C16.2888 23.93 16.45 23.7688 16.45 23.57V23.16C16.45 22.9612 16.2888 22.8 16.09 22.8Z"
        fill={color}
      />
    </svg>
  );
};

export default KrGateway;
